import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

export const AUTH_MODE = process.env.REACT_APP_AUTH_MODE || 'bypass';

let app = null;
let auth = null;
let googleProvider = null;
export let initError = null;

if (AUTH_MODE === 'firebase') {
  const apiKey = process.env.REACT_APP_FIREBASE_API_KEY;
  const authDomain = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  const appId = process.env.REACT_APP_FIREBASE_APP_ID;

  if (!apiKey || !projectId) {
    initError = 'Firebase mode enabled but config is missing. Set REACT_APP_FIREBASE_* in .env.';
    console.error('[ELM Auth]', initError);
  } else {
    try {
      app = initializeApp({ apiKey, authDomain, projectId, appId });
      auth = getAuth(app);
      googleProvider = new GoogleAuthProvider();
    } catch (err) {
      initError = err?.message || String(err);
      console.error('[ELM Auth] Firebase initialization failed:', initError);
    }
  }
}

export { app, auth, googleProvider };
